<div class="container-card slide-element" *ngIf="visible" 
    [@fadePulseAnimation] (@fadePulseAnimation.done)="slideAnimationDone($event)">
    <div class="background" style="background-image: url('layout/images/info/helpdesk.png')"></div>
    <p-card [header]="header" [subheader]="subheader"
        styleClass="p-card-shadow card-info-page">
        <p [innerHTML]="description"></p>
        <ng-template pTemplate="footer">
            <p-menu #menuClose [popup]="true" [model]="optionsCloseCardInfo" appendTo="body"></p-menu>
            <button type="button" pButton icon="pi pi-times" [label]="'buttons.fechar' | translate"
                severity="danger" (click)="menuClose.toggle($event)"></button>
        </ng-template>
    </p-card>
</div>